<div
  class="user-icon-menu-container"
  [class.shadow-mode]="shadowMode"
>
  <button
    mat-mini-fab
    class="trigger"
    [matMenuTriggerFor]="menu"
    data-testid="user-menu-trigger"
    (menuOpened)="onMenuTrigger()"
    (menuClosed)="onMenuClosed()"
    #menuTrigger="matMenuTrigger"
  >
    <span>{{ user | initials }}</span>
  </button>
  <app-shadow-widget *ngIf="shadowMode"></app-shadow-widget>
  <mat-menu
    #menu="matMenu"
    class="user-icon-menu"
    xPosition="before"
    [overlapTrigger]="true"
  >
    <ng-template matMenuContent>
      <div
        class="top"
        (click)="$event.stopPropagation()"
      >
        <button
          mat-icon-button
          class="button-close"
          (click)="menuTrigger.closeMenu()"
        >
          <mat-icon svgIcon="close"></mat-icon>
        </button>
        <div
          class="initials"
          routerLink="/account"
          (click)="onInitialsClick(); menuTrigger.closeMenu()"
        >
          {{ user | initials }}
        </div>
        <div
          class="name-wrapper"
          [class.client-user]="isClientUser"
        >
          <div class="full-name">{{ user.fullName }}</div>
          <div class="username">{{ user.email }}</div>
          <app-account-level-badge
            (click)="menuTrigger.closeMenu()"
            source="Account Status Badge - User Icon Menu"
          ></app-account-level-badge>
        </div>
      </div>
      <app-account-upgrade-button
        class="account-upgrade-button-user-icon-menu"
        source="Upgrade Button - User Icon Menu"
      ></app-account-upgrade-button>
      <mat-divider></mat-divider>
      <a
        mat-menu-item
        class="portal"
        [class.not-upgradable]="!isUpgradable"
        [routerLink]="user.portalLink"
      >
        {{ user.portalName }}
      </a>
      <ng-container *ngIf="user.additionalMenuNav">
        <a
          mat-menu-item
          [routerLink]="nav.path"
          class="portal"
          [class.not-upgradable]="!isUpgradable"
          (click)="onAdditionalNavClick(nav)"
          *ngFor="let nav of user.additionalMenuNav"
        >
          {{ nav.label }}
        </a>
      </ng-container>
      <mat-accordion
        class="profile-links"
        (click)="$event.stopPropagation()"
        displayMode="flat"
        *ngIf="partnerVenues?.length > 0"
      >
        <mat-expansion-panel>
          <mat-expansion-panel-header
            collapsedHeight="48px"
            expandedHeight="48px"
          >
            <mat-panel-title>Profile Links</mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <a
              mat-menu-item
              *ngFor="let venue of partnerVenues"
              [href]="venue[1]"
              rel="noopener nofollow noreferrer"
              target="_blank"
            >
              {{ venue[0].venueName }}
            </a>
          </ng-template>
        </mat-expansion-panel>
      </mat-accordion>
      <a
        mat-menu-item
        routerLink="/account"
        (click)="onAccountSettingsNavClick()"
      >
        <span
          [newFeatureBadge]="isAdminUser"
          new-badge-mode="dot"
          >Account Settings</span
        >
      </a>
      <a
        mat-menu-item
        routerLink="/prod-support"
        (click)="onProdSupportNavClick()"
        *ngIf="showSupport"
      >
        Prod Support
      </a>
      <a
        mat-menu-item
        routerLink="/api"
        (click)="onApiNavClick()"
        *ngIf="showDevelopers"
      >
        {{ PRODUCT_NAME }} API
      </a>
      <ng-container *ngIf="includeExtras">
        <mat-divider></mat-divider>
        <a
          mat-menu-item
          href="mailto:{{ HELP_EMAIL }}"
          rel="noopener nofollow noreferrer"
        >
          {{ HELP_EMAIL }}
        </a>
      </ng-container>
      <mat-divider></mat-divider>
      <a
        mat-menu-item
        class="referral-link"
        *ngIf="showReferralRewards"
        (click)="onReferralRewardsClick()"
      >
        Refer and Earn
        <mat-icon svgIcon="paid"></mat-icon>
      </a>
      <a
        mat-menu-item
        *ngIf="showPartnerHelp"
        (click)="onPartnerHelpClick()"
      >
        Help Center
      </a>
      <mat-divider *ngIf="showPartnerHelp"></mat-divider>
      <button
        mat-menu-item
        (click)="logout()"
      >
        <span>{{ logoutLabel() }}</span>
      </button>
    </ng-template>
  </mat-menu>
</div>
